const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v2/auth`;

export const loginService = async (username, password) => {
  try {
    const response = await fetch(`${API_URL}/login/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: username, 
        password: password,
      }),
    });

    if (!response.ok) {
      // Intentamos capturar el mensaje exacto del backend
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Error ${response.status}: Credenciales inválidas`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en loginService:", error);
    throw error;
  }
};